import React from "react";
import { Link } from "react-router-dom";

import { Trans } from "app/utils";

import styles from "./not-found.module.scss";

type NotFoundProps = {
  redirect?: string;
};

const NotFound: React.FC<NotFoundProps> = ({ redirect }) => (
  <div className={styles.container}>
    <h1>
      <Trans>Uh oh!</Trans>
    </h1>
    <hr />
    <p>
      <Trans>
        The page you were looking for cannot be found. We&#39;re sorry for the
        inconvenience. Please contact support with any questions.
      </Trans>
      {" "}
      {redirect ? (
        <a href={redirect}><Trans>Return home</Trans></a>
      ) : (
        <Link to="/"><Trans>Return home</Trans></Link>
      )}
    </p>
  </div>
);

export default NotFound;
